import { CardStackSocket } from "../../types/types";
import { TableStack } from "./TableStack";

export class TableStackInit extends TableStack
{

    public override Init(): void
    {
        super.Init();
    }

    /**
     * 
     * @param playerIndex 0=top, 1=right, 2=bot, 3=left
     */
    public override GetSocket(): CardStackSocket
    {
        // TODO: use template 
        // const socketTemplate: CardStackSocket = this.cardStackSocketTemplates[0];
        // return new random socket
        return {
            posX: Phaser.Math.FloatBetween(-3,3),
            posY: Phaser.Math.FloatBetween(-3,3),
            angle: Phaser.Math.FloatBetween(-15,15),
        }
    }
}